$(window).load(function() {

	/* Slideshow */
	$("#slideshow").flexslider({
		animation: "slide",
		slideDirection: "vertical",
		slideshow: true,
		directionNav: false,
		controlNav: false,
		keyboardNav: false,
		pauseOnHover: true 
	});
	
	/* New Products */
	$("#new-products").flexslider({
		animation: "slide",
		slideshow: true,
		directionNav: true,
		controlNav: false,
		keyboardNav: false,
		pauseOnHover: true 
	});

});

$(document).ready(function() {

	/* Toggle Cart */
	$(".toggle").click(function() { 
		$("#checkout").fadeToggle();
		return false;
	});
	
	/* Toggle Menu on Smartphones */
	$("#open").click(function() {
		$("nav").slideToggle("fast");
		$(this).toggleClass("active");
	});
	
	/* Clear Search */
	$("#search input[type='text']").focus();
	$("#search input[type='text']").focus(function() {
		var value = $(this).attr("value");
		if(value == "Search") {
			$(this).attr("value","");
		}
	}).focusout(function () {
		var value = $(this).attr("value");
		if(value == "") {
			$(this).attr("value","Search");
		}
	});
	
	/* Clear Newsletter Input */
	$("#newsletter input[type='text']").focus(function() {
		var value = $(this).attr("value");
		if(value == "Your E-Mail Address") {
			$(this).attr("value","");
		}
	}).focusout(function () {
		var value = $(this).attr("value");
		if(value == "") {
			$(this).attr("value","Your E-Mail Address");
		}
	});
	
	/* Overlay Control */
    $("#featured li > a").click(function() {
		$(".overlay").fadeOut("fast");
		$(this).parent("li").find(".overlay").fadeIn("fast");
		return false;
	});
	
	$("#products .thumbnail > a").click(function() {
		$(".overlay").fadeOut("fast");
		$(this).parent("div").parent("li").find(".overlay").fadeIn("fast");
		return false;
	});
	
	$(".overlay").click(function() {
		$(this).fadeOut("fast");
	});
	
	/* Extended Menu Toggle */
	$(".dropdown").click(function() {
    	if ($("#extended").is(":hidden")) {
			$("menu").removeClass("rounded");
			$("nav").removeClass("rounded");
	    	$("#extended").slideDown();
	    } else {
			$("menu").addClass("rounded");
			$("nav").addClass("rounded");
		    $("#extended").slideUp();
		}
		$(this).toggleClass("open");
		return false;
	});
	
	/* Tab Control */
	$(".tabs a").click(function() {
		$("#recent > div").hide();
		$(".tabs li").removeClass("active");
		$(this).parent("li").addClass("active");
		var target = $(this).attr("href");
		$(target).fadeIn("fast");
		return false;
	});
	
	/* Product Image Control */
	$("#product-images a").click(function() {
		var target = $(this).find("img").attr("src");
		if(target) {
			$("#product-featured-image img").attr("src",target);
		}
		return false;
	});
	
	/* Scrollbar */
	$("#featured").tinyscrollbar({ 
		axis: "x",
		invertscroll: true 
	});
	$("#extended").hide();
	
	/* Twitter Feed */
	$(".stream").tweet({
		join_text: "auto",
		username: "indiqo",
		count: 3,
		loading_text: "Loading Tweets..",
		template: "{text}{time}"
	});

});

$(window).resize(function() {
	
	/* Resize Scrollbar */
	$("#featured").tinyscrollbar_update();
	
});